import styled from 'astroturf/react'
const colorStrokeStandard = 'var(--colorStrokeStandard, var(--coreColorNeutral400))'
const colorTextAction = 'var(--colorTextAction, var(--coreColorBlue700))'
import { useSelector } from 'react-redux'
import { parseInTimezone } from '@calendly/datetime'
import { forwardRef } from 'react'
import { formatTime } from '@calendly/booking-kit/services/time_format'

import { useMutualAvailabilityEnabled } from 'components/mutual_availability/use_mutual_availability_enabled'
import { timeNotationSelector, timezoneSelector } from 'selectors'
import { isNoTouchDevice } from 'services/touch_device_detection'

import { SpotButton } from './spot_button'
import { TimeButtonStyledMarker, TimeButtonTimeDisplay, TimeButtonWrapper } from './styles'
import _Container from "time_button-Container.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/select_date_time/time_button.js?styleId=Container";


const Container = /*#__PURE__*/styled(SpotButton, null, {
  displayName: "Container",
  styles: _Container,
  attrs: props => ({
    ...props,
    isNoTouchDevice: isNoTouchDevice()
  })
})


export const TimeButton = forwardRef(({ spot, onClick, isSelected, hasFreeMarker, children, timeFormat12h, ...rest }, forwardedRef) => {
  const isMutualAvailabilityEnabled = useMutualAvailabilityEnabled()
  const timeNotation = useSelector(timeNotationSelector)
  const timezone = useSelector(timezoneSelector)
  const parsedTime = parseInTimezone(spot.start_time, timezone)
  const time = formatTime(parsedTime, timeNotation, timeFormat12h)

  return (
    <Container onClick={onClick} ref={forwardedRef} {...rest}>
      <TimeButtonWrapper timeNotation={timeNotation}>
        {!isSelected && isMutualAvailabilityEnabled && hasFreeMarker && <TimeButtonStyledMarker data-id="marker" />}
        <TimeButtonTimeDisplay>{time}</TimeButtonTimeDisplay>
        {children}
      </TimeButtonWrapper>
    </Container>
  )
})
